'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var conversionUtils = require("../conversionUtils");
var EQUALITY_DEVIATION_THRESHOLD = 0.1;
var getSign = function (n) { return n === 0 ? 0 : n / Math.abs(n); };
exports.getSign = getSign;
var getComponentSize = function (comp, dim) { return dim === 'x' ? comp.layout.width : comp.layout.height; };
exports.getComponentSize = getComponentSize;
var getComponentEndCoordinate = function (comp, axis) { return comp.layout[axis] + getComponentSize(comp, axis); };
exports.getComponentEndCoordinate = getComponentEndCoordinate;
var compareComponentsByY = function (c1, c2) { return getSign(c1.layout.y - c2.layout.y); };
exports.compareComponentsByY = compareComponentsByY;
function haveSimilarCoordinates(comp1, comp2, dim, deviationThreshold) {
    if (deviationThreshold === void 0) { deviationThreshold = EQUALITY_DEVIATION_THRESHOLD; }
    var v1 = _.get(comp1, ['layout', dim]);
    var v2 = _.get(comp2, ['layout', dim]);
    return Math.abs(v1 - v2) <= deviationThreshold * _.min([getComponentSize(comp1, dim), getComponentSize(comp2, dim)]);
}
function similarBy(comp1, comp2, valuePath, deviationThreshold) {
    if (deviationThreshold === void 0) { deviationThreshold = EQUALITY_DEVIATION_THRESHOLD; }
    var v1 = _.get(comp1, valuePath);
    var v2 = _.get(comp2, valuePath);
    return Math.abs(v1 - v2) <= deviationThreshold * _.min([v1, v2]);
}
function areSimilarFragments(fragment1, fragment2, dimension) {
    if (fragment1 === fragment2) {
        return true;
    }
    if (_.size(fragment1) !== _.size(fragment2) || shouldBreakFragment(fragment1, dimension) || shouldBreakFragment(fragment2, dimension)) {
        return false;
    }
    return _.every(fragment1, function (comp1, compIndex) {
        var comp2 = fragment2[compIndex];
        return comp1.componentType === comp2.componentType && haveSimilarCoordinates(comp1, comp2, dimension) &&
            (comp1.conversionData.category === 'text' ? similarBy(comp1, comp2, ['conversionData', 'averageNormalizedFontSize']) :
                similarBy(comp1, comp2, ['layout', 'height']) && similarBy(comp1, comp2, ['layout', 'width']));
    });
}
exports.areSimilarFragments = areSimilarFragments;
function shouldBreakFragment(fragment, dimension) {
    var firstDistantCompIndex = _.findIndex(fragment, function (comp, compIndex) {
        if (compIndex === 0) {
            return false;
        }
        var previousCompEnd = getComponentEndCoordinate(fragment[compIndex - 1], dimension);
        var distance = comp.layout[dimension] - previousCompEnd;
        return distance < 0 || distance > _.min([getComponentSize(fragment[compIndex - 1], dimension), getComponentSize(comp, dimension)]);
    });
    return firstDistantCompIndex !== -1 && firstDistantCompIndex !== fragment.length - 1;
}
function getOrderedComponents(parent) {
    var children = conversionUtils.getChildren(parent);
    return _.map(parent.conversionData.componentsOrder, function (id) { return _.find(children, { id: id }); });
}
exports.getOrderedComponents = getOrderedComponents;
var shouldUseNaturalOrder = function (comp) {
    return conversionUtils.isRescaleVirtualGroup(comp) && comp.conversionData.rescaleMethod !== 'reorder' ||
        comp.conversionData.structuralContainer;
};
exports.shouldUseNaturalOrder = shouldUseNaturalOrder;
function sortComponentsByNaturalOrder(parent, comps) {
    var childrenIds = _.map(conversionUtils.getChildren(parent), 'id');
    return _.sortBy(comps, function (comp) { return childrenIds.indexOf(comp.id); });
}
exports.sortComponentsByNaturalOrder = sortComponentsByNaturalOrder;
function hasMobileHintsPresets(comp) {
    var mobileHints = _.pick(comp.conversionData.mobileHints, ['recommendedWidth', 'recommendedHeight', 'recommendedScale', 'recommendedOrder']);
    return !_.isEmpty(mobileHints);
}
exports.hasMobileHintsPresets = hasMobileHintsPresets;



//////////////////
// WEBPACK FOOTER
// ./src/mobileCore/main/analyzer/analyzerUtils.ts
// module id = 4
// module chunks = 0 1